import { getFromLocalStorage, setInLocalStorage } from './localStorage';

// Experimental LocalStorage key
const EXP_KEY = 'tcc_exp_features';

/**
 * LocalStorage getter wrapper
 * @returns {Object} EXP_KEY json parsed values from LocalStorage
 */
export function getAllExperiments() {
  return getFromLocalStorage(EXP_KEY);
}

/**
 * @param {String} id Module Id
 * @return {String?} Experimental Hash
 */
export function getExperimentHash(id) {
  const experiments = getAllExperiments();
  return experiments ? experiments[id] : null;
}

/**
 * @param {String} id Module Id
 * @param {String} hash New Experiment Hash
 * @returns {String} Experiments Hash
 */
export function setExperimentHash(id, hash) {
  const exps = getAllExperiments();
  const newExps = { ...exps, [id]: hash };
  setInLocalStorage(EXP_KEY, newExps);
  return getExperimentHash(id);
}

/**
 * @param {Object} newExps New Experiment Object
 * @returns {Object} All Experiments
 */
export function setBatchExperiments(newExps) {
  const exps = getAllExperiments();
  const updatedExps = {...exps, ...newExps};
  setInLocalStorage(EXP_KEY, updatedExps);
  return getAllExperiments();
}

/**
 * @param {String} id
 * @returns {String} Experiments Hash new value
 */
export function clearExperimentHash(id) {
  try {
    const exps = getAllExperiments();
    delete exps[id];
    setInLocalStorage(EXP_KEY, exps);
    return true;
  } catch (e) {
    throw new Error('Error clearing the Hash', e);
  }
}

/**
 * Sets the experiments key to be null
 * @returns {Void}
 */
export function clearAllExperiments() {
  try {
    setInLocalStorage(EXP_KEY, null);
  } catch (e) {
    throw new Error('Error clearing all the experiments', e);
  }
}